import React, { useEffect, useState } from "react";
import { CommonUtilities } from "../../commonUtils";
import Header from "../Header/header";
import { Modal } from 'react-responsive-modal';
import NewTransactionBox from "./NewTransaction";
import InvoiceCheckBox from "./InvoiceCheck";
import TransactionServices from "./TransactionServices";
import InvoiceDetailBox from "./InvoiceDetail";
import EditInvoiceBox from "./EditInvoice";
import { tr } from "date-fns/locale";


export default function Transactions(subEntity: any) {
    const [showtab, setShowTab] = useState(1);
    const [loop, setloop] = useState(1);
    let [activeMenu, setActiveMenu] = useState("Transactions");
    const [searchFor, setSearchFor] = useState("");
    var dataLink = "pageSize=10&pageNumber=1";
    const [currentList, initCurrentList] = useState<any[]>([]);
    const [totalRows, setTotalRows] = useState(1);

    const onChangeMenu = (e: any) => {
        console.log(e)
        setActiveMenu(e)
    }
    let [factSaleDeleteFlag, setfactSaleDeleteFlag] = useState(false);
    let [factSaleArchiveFlag, setfactSaleArchiveFlag] = useState(false);
    let [postApprovedtrue, setpostApprovedtrue] = useState(false);
    let [postApprovedfalse, setpostApprovedfalse] = useState(false);
    let [RecycleFlag, setRecycleFlag] = useState(false);
    let [invoicesTotalItems, setinvoicesTotalItems] = useState(false);
    let [dateError, setDateError] = useState(false);
    let [periodError, setPeriodError] = useState(false);



    let [viewAll, setViewAll] = useState<any[]>([]);
    const SearchListing = () => {
        TransactionServices.getViewAll({}).then((res: any) => {
            console.log(res)
            viewAll = res
            setViewAll(res)
            console.log("test for view all button")
        })
    }
    let [invoiceCheckList, setInvoiceCheck] = useState<any>([]);
    const invoiceList = () => {
        var payload = { headerType: "digital", royaltyPeriod: "20240331", accountCode: '', invoiceNum: '', approvedStatus: '', pageNumber: 1, pageSize: 10 }
        TransactionServices.getInvoiceCheckDetails(payload).then((res: any) => {
            console.log(res)
            invoiceCheckList = res
            setInvoiceCheck(res)
        })
    }

    const Data: any = {
        pageSize: 10,
        pageNumber: 1,
        totalRows: 0
    }

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        dataLink = 'pageSize=' + Data.pageSize + '&pageNumber=' + Data.pageNumber;
        currentPage(showtab)
    }

    const currentPage = (e: number) => {
        setShowTab(e);

        if (searchFor.length > 0) {
            dataLink = dataLink + "&searchFor=" + searchFor
        }
        if (e === 1) {
            TransactionServices.PublishingSong(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 2) {
            TransactionServices.PublishingWriter(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 3) {
            TransactionServices.Digital(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 4) {
            TransactionServices.Physical(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 5) {
            TransactionServices.Costs(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 6) {
            TransactionServices.Advances(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 7) {
            TransactionServices.Licensing(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 8) {
            TransactionServices.Adjustments(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }

    }

    let [newTransactionStatus, setNewTransactionStatus] = useState(false);
    const newTransaction = () => {
        setNewTransactionStatus(true)
    }
    let [openNewTransaction, setOpenNewTransaction] = useState(false);
    const NewTransactionClose = () => {
        newTransactionStatus = false
        setNewTransactionStatus(false)
    }
    
    let [invoiceCheckStatus, setInvoiceCheckStatus] = useState(false);
    const invoiceCheck = () => {
        setInvoiceCheckStatus(true)
    }
    let [openInvoiceCheck, setOpenInvoiceCheck] = useState(false);
    const InvoiceCheckClose = () => {
        invoiceCheckStatus = false
        setInvoiceCheckStatus(false)
    }

    let [invoiceDetailStatus, setInvoiceDetailStatus] = useState(false);
    const invoiceDetail = () => {
        invoiceDetailStatus = true;
        setInvoiceDetailStatus(invoiceDetailStatus)
    }
    let [openInvoiceDetails, setOpenInvoiceDetails] = useState(false);
    const InvoiceDetailClose = () => {
        invoiceDetailStatus = false
        setInvoiceDetailStatus(false)
    }





    let [editInvoiceStatus, setEditInvoiceStatus] = useState(false);
    const editInvoice = () => {
        editInvoiceStatus = true;
        setEditInvoiceStatus(editInvoiceStatus)
    }

    let [openEditInvoice, setOpenEditInvoice] = useState(false);
    const EditInvoiceClose = () => {
        editInvoiceStatus = false
        setEditInvoiceStatus(false)
    }



    return (
        <div className="ws-12 box">
            <div className="ws-12">
                <ul className="nav nav-tabs nav-justified pLarge">
                    <li className="hide active"><a className="active" href="#/salesAnalysis/publishingSong">Publishing - Song</a> </li>
                    <li className="hide active"><a href="#/salesAnalysis/publishingWriter">Publishing - Writer</a></li>
                    <li className="hide active"><a href="#/salesAnalysis/digital">Digital</a></li>
                    <li className="hide active"><a href="#/salesAnalysis/physical">Physical</a></li>
                    <li className="hide active"><a href="#/salesAnalysis/costs">Costs</a></li>
                    <li className="hide active"><a href="#/salesAnalysis/advances">Advances</a></li>
                    <li className="hide active"><a href="#/salesAnalysis/licensing">Licensing</a></li>
                    <li className="hide active"><a href="#/salesAnalysis/adjustments">Adjustments</a></li>

                    <a id="1" className={showtab === 1 ? "btn-success active" : "btn-success"} onClick={() => currentPage(1)}>Publishing - Song</a>
                    <a id="2" className={showtab === 2 ? "btn-success active" : "btn-success"} onClick={() => currentPage(2)}>Publishing - Writer</a>
                    <a id="3" className={showtab === 3 ? "btn-success active" : "btn-success"} onClick={() => currentPage(3)}>Digital</a>
                    <a id="4" className={showtab === 4 ? "btn-success active" : "btn-success"} onClick={() => currentPage(4)}>Physical</a>
                    <a id="5" className={showtab === 5 ? "btn-success active" : "btn-success"} onClick={() => currentPage(5)}>Cost</a>
                    <a id="6" className={showtab === 6 ? "btn-success active" : "btn-success"} onClick={() => currentPage(6)}>Advances</a>
                    <a id="7" className={showtab === 7 ? "btn-success active" : "btn-success"} onClick={() => currentPage(7)}>Licensing</a>
                    <a id="8" className={showtab === 8 ? "btn-success active" : "btn-success"} onClick={() => currentPage(8)}>Adjustments</a>
                </ul>

                <div className="ws-12">
                    <div className="box">
                        <div className="box-header well">
                            <h2>
                                <i className="icon-search"></i> Publishing Song Transaction Listing
                            </h2>
                        </div>
                        <div className="box-content" ng-show="invoiceform">
                            <div className="form-horizontal form-condensed ng-pristine ng-valid ng-valid-date">
                                {
                                    dateError && <div className="alert alert-info">Please select a Date From and a Date To</div>
                                }
                                {
                                    periodError && <div className="alert alert-info">Please select a period first</div>
                                }

                                <div className="ws-12">

                                    <div className="ws-2 mbl">
                                        <span className="pull-left mrl ">Filter transactions by </span>
                                    </div>

                                    <div className="ws-6 mbl">
                                        <div >
                                            <div className="input-group">
                                                <label className="pull-left mrl ">
                                                    <input type="radio" name="filterByDate" data-ng-model="filterByDate" value="yes" data-ng-init="filterByDate = 'yes'" /> date
                                                </label>
                                                <label className="pull-left mrl ">
                                                    <input type="radio" name="filterByDate" value="no" ng-model="filterByDate" /> approval status
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="ws-12">
                                    <div className="ws-4">
                                        <div className="input-group">
                                            <span className="input-group-addon pr"><i className="fa fa-calendar"></i> Date From</span>
                                            <input type="text" placeholder="Select a Date" readOnly />
                                        </div>
                                    </div>

                                    <div className="ws-4">
                                        <div className="input-group" title="Leave blank to set same as Date From">
                                            <span className="input-group-addon pr "><i className="fa fa-calendar"></i> Date To</span>
                                            <input type="text" placeholder="Select a Date" ng-model="invoiceDateTo" readOnly />
                                        </div>
                                    </div>
                                </div>

                                <div className="box-footer mtl">
                                    <a className="icon-btn edit pull-left " onClick={() => newTransaction()}>New Transaction</a>
                                    <a className="icon-btn primary pull-right " onClick={invoiceCheck}>Invoice Check</a>
                                    <a className="icon-btn edit pull-right " onClick={SearchListing}>View All</a>
                                    <a className="btn icon-btn edit pull-right" ng-click="onInvoiceSearchByDate(invoiceDateFrom, invoiceDateTo)" title="Search"><i className="icon-search"></i> Search</a>
                                    <a className="icon-btn edit pull-left " onClick={() => invoiceDetail()}>Details</a>
                                    <a className="btn icon-btn edit mgl " onClick={() => editInvoice()}>Edit</a>
                                </div>
                            </div>
                            <div className="hide ws-12 mbl ng-hide" data-ng-show="filterByDate == 'no'">
                                <div className="ws-6">
                                    <label className="pull-left mrl ">
                                        <input type="radio" data-ng-model="chkApprovedInvoices" data-ng-init="chkApprovedInvoices = null" data-ng-value="null" name="694" /> All
                                    </label>
                                    <label className="pull-left mrl ">
                                        <input type="radio" data-ng-model="chkApprovedInvoices" data-ng-value="true" name="695" value="true" /> Approved
                                    </label>
                                    <label className="pull-left mrl ">
                                        <input type="radio" data-ng-model="chkApprovedInvoices" data-ng-value="false" name="696" value="false" /> Un-Approved
                                    </label>
                                </div>
                                <div className="ws-6">
                                    <div className="input-group">
                                        <span className="input-group-addon  "><i className="fa fa-calendar"></i> Period</span>
                                        <select className="optionSpacer " data-ng-change="showResetWarning(periodFilter)" ng-model="periodFilter">
                                            <option value="20140331" className="btn">
                                                Jan 1, 2014 - Mar 31, 2014
                                            </option><option value="20140630" className="btn">
                                                Apr 1, 2014 - Jun 30, 2014
                                            </option><option value="20140930" className="btn">
                                                Jul 1, 2014 - Sep 30, 2014
                                            </option><option value="20141231" className="btn">
                                                Oct 1, 2014 - Dec 31, 2014
                                            </option><option value="20150331" className="btn">
                                                Jan 1, 2015 - Mar 31, 2015
                                            </option><option value="20150630" className="btn">
                                                Apr 1, 2015 - Jun 30, 2015
                                            </option><option value="20150930" className="btn">
                                                Jul 1, 2015 - Sep 30, 2015
                                            </option><option value="20151231" className="btn">
                                                Oct 1, 2015 - Dec 31, 2015
                                            </option><option value="20160331" className="btn">
                                                Jan 1, 2016 - Mar 31, 2016
                                            </option><option value="20160630" className="btn">
                                                Apr 1, 2016 - Jun 30, 2016
                                            </option><option value="20160930" className="btn">
                                                Jul 1, 2016 - Sep 30, 2016
                                            </option><option value="20161231" className="btn">
                                                Oct 1, 2016 - Dec 31, 2016
                                            </option><option value="20170331" className="btn">
                                                Jan 1, 2017 - Mar 31, 2017
                                            </option><option value="20170630" className="btn">
                                                Apr 1, 2017 - Jun 30, 2017
                                            </option><option value="20170930" className="btn">
                                                Jul 1, 2017 - Sep 30, 2017
                                            </option><option value="20171231" className="btn">
                                                Oct 1, 2017 - Dec 31, 2017
                                            </option><option value="20180331" className="btn">
                                                Jan 1, 2018 - Mar 31, 2018
                                            </option><option value="20180630" className="btn">
                                                Apr 1, 2018 - Jun 30, 2018
                                            </option><option value="20180930" className="btn">
                                                Jul 1, 2018 - Sep 30, 2018
                                            </option><option value="20181231" className="btn">
                                                Oct 1, 2018 - Dec 31, 2018
                                            </option><option value="20190331" className="btn">
                                                Jan 1, 2019 - Mar 31, 2019
                                            </option><option value="20190630" className="icon-btn edit opacityDisabled">
                                                Apr 1, 2019 - Jun 30, 2019
                                            </option><option value="20190930" className="icon-btn edit opacityDisabled">
                                                Jul 1, 2019 - Sep 30, 2019
                                            </option><option value="20191231" className="icon-btn edit opacityDisabled">
                                                Oct 1, 2019 - Dec 31, 2019
                                            </option><option value="20200331" className="icon-btn edit opacityDisabled">
                                                Jan 1, 2020 - Mar 31, 2020
                                            </option><option value="20200630" className="icon-btn edit opacityDisabled">
                                                Apr 1, 2020 - Jun 30, 2020
                                            </option><option value="20200930" className="icon-btn edit opacityDisabled">
                                                Jul 1, 2020 - Sep 30, 2020
                                            </option><option value="20201231" className="icon-btn edit opacityDisabled">
                                                Oct 1, 2020 - Dec 31, 2020
                                            </option><option value="20210331" className="icon-btn edit opacityDisabled">
                                                Jan 1, 2021 - Mar 31, 2021
                                            </option><option value="20210630" className="icon-btn edit opacityDisabled">
                                                Apr 1, 2021 - Jun 30, 2021
                                            </option><option value="20210930" className="icon-btn edit opacityDisabled">
                                                Jul 1, 2021 - Sep 30, 2021
                                            </option><option value="20211231" className="icon-btn edit opacityDisabled">
                                                Oct 1, 2021 - Dec 31, 2021
                                            </option><option value="20220331" className="icon-btn edit opacityDisabled">
                                                Jan 1, 2022 - Mar 31, 2022
                                            </option><option value="20220630" className="icon-btn edit opacityDisabled">
                                                Apr 1, 2022 - Jun 30, 2022
                                            </option><option value="20220930" className="icon-btn edit opacityDisabled">
                                                Jul 1, 2022 - Sep 30, 2022
                                            </option><option value="20221231" className="icon-btn edit opacityDisabled">
                                                Oct 1, 2022 - Dec 31, 2022
                                            </option><option value="20230331" className="icon-btn edit opacityDisabled">
                                                Jan 1, 2023 - Mar 31, 2023
                                            </option><option value="20230630" className="icon-btn edit opacityDisabled">
                                                Apr 1, 2023 - Jun 30, 2023
                                            </option><option value="20230930" className="icon-btn edit opacityDisabled">
                                                Jul 1, 2023 - Sep 30, 2023
                                            </option><option value="20231231" className="icon-btn edit opacityDisabled">
                                                Oct 1, 2023 - Dec 31, 2023
                                            </option><option value="20240331" className="icon-btn edit opacityDisabled" selected>
                                                Jan 1, 2024 - Mar 31, 2024
                                            </option><option value="20240630" className="icon-btn edit opacityDisabled">
                                                Apr 1, 2024 - Jun 30, 2024
                                            </option><option value="20240930" className="icon-btn edit opacityDisabled">
                                                Jul 1, 2024 - Sep 30, 2024
                                            </option><option value="20241231" className="icon-btn edit opacityDisabled">
                                                Oct 1, 2024 - Dec 31, 2024
                                            </option><option value="20250331" className="icon-btn edit opacityDisabled">
                                                Jan 1, 2025 - Mar 31, 2025
                                            </option><option value="20250630" className="icon-btn edit opacityDisabled">
                                                Apr 1, 2025 - Jun 30, 2025
                                            </option><option value="20250930" className="icon-btn edit opacityDisabled">
                                                Jul 1, 2025 - Sep 30, 2025
                                            </option><option value="20251231" className="icon-btn edit opacityDisabled">
                                                Oct 1, 2025 - Dec 31, 2025
                                            </option><option value="20260630" className="icon-btn edit opacityDisabled">
                                                Jan 1, 2026 - Jun 30, 2026
                                            </option><option value="20261231" className="icon-btn edit opacityDisabled">
                                                Jul 1, 2026 - Dec 31, 2026
                                            </option><option value="20270630" className="icon-btn edit opacityDisabled">
                                                Jan 1, 2027 - Jun 30, 2027
                                            </option><option value="20271231" className="icon-btn edit opacityDisabled">
                                                Jul 1, 2027 - Dec 31, 2027
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div className="ws-12 box-footer mtl">
                                    <a className="hide btn icon-btn edit " data-ng-click="searchByPeriod()"><i className="icon-search"></i>Search</a>
                                    <a className="hide btn icon-btn edit mgl " onClick={SearchListing}><i className="icon-search"></i> View All</a>
                                    <a className="hide btn icon-btn edit mgl " onClick={() => invoiceDetail()}>Detail</a>
                                    <a className="hide btn icon-btn edit mgl " onClick={() => editInvoice()}>Edit</a>
                                    <a className="hide tn-primary pull-right " onClick={() => InvoiceCheckBox}>Invoice Check</a>
                                    <a className="hide icon-btn edit pull-left " onClick={() => newTransaction()}>New Transaction</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="ws-12 box">
                    <div className="box-header well">
                        <h2 ng-bind="'Search result for ' + invDate + ' - ' + allFinvoices.length + ' record(s) found' ">Search result for  - 0 record(s) found</h2>
                    </div>

                    <div className="box-content">
                        {
                            factSaleDeleteFlag && <div className="alert alert-info">The invoice account for has been deleted successfully</div>
                        }
                        {
                            factSaleArchiveFlag && <div className="alert alert-info">The invoice has been archieved successfuly and is currently been deleted Please return Post Approved.</div>
                        }
                        {
                            postApprovedtrue && <div className="alert alert-info">Operation queued for processing</div>
                        }
                        {
                            postApprovedfalse && <div className="alert alert-info">Re-run this operation after a few mins as similar job already in progress</div>
                        }
                        {
                            RecycleFlag && <div className="alert alert-info">Invoice queued for recycling</div>
                        }

                        <div className="form-box row-fluid t_margin ng-hide" data-ng-hide="invoices.length == 0">
                            <div className="form-horizontal row-fluid">
                                <div className="form-format ws-6">
                                    <label className="control-label ">Filter invoices</label>
                                    <div className="label-entries">
                                        <input id="filterInvoiceTbl" type="text" className="input-sm " data-ng-model="filterInvoiceTbl" placeholder="Search" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="alert alert-info  hide" data-ng-show="invoicesTotalItems == 0">
                            {
                                invoicesTotalItems && <div className="alert alert-info">No records found</div>
                            }
                        </div>
                        <div className="table-responsive_big">
                            <a className="btn icon-btn warning pull-right mb  ng-hide" ng-click="appAll()" data-ng-show="invoicesTotalItems &gt; 0"><i className="icon-tick"></i> Approve All Invoice(s) </a>
                            <table className="table ng-hide" data-ng-show="invoicesTotalItems &gt; 0">
                                <thead>
                                    <tr>
                                        <th>Account</th>
                                        <th>Invoice</th>
                                        <th>Transaction Ref</th>
                                        <th>Home Value</th>
                                        <th>Currency</th>
                                        <th>Curr Value</th>
                                        <th>Exch Rate</th>
                                        <th>Royalty Period</th>
                                        <th>Invoice Date</th>
                                        <th>Approve</th>
                                        <th>Operation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {viewAll?.map(values => {
                                        return (
                                            <tr>
                                                <td>{values.accountCode}</td>
                                                <td>{values.invoiceNum}</td>
                                                <td>{values.transactionRef}</td>
                                                <td>{values.homeValue}</td>
                                                <td>{values.currencySign}</td>
                                                <td>{values.currencyValue}</td>
                                                <td>{values.exchRate1}</td>
                                                <td>{values.royaltyPeriod}</td>
                                                <td>{values.invoiceDate}</td>
                                            </tr>
                                        )
                                    })}
                                    <td>
                                        <div className="row-fluid form-condensed mt">
                                            <div className="ws-2">
                                                <a className="btn-sm icon-btn warning pull-right mr " ng-click="invoicePostApproved(quarterlyPeriod)"><i className="icon-tick"></i>
                                                    Post Approved</a>
                                            </div>
                                            <div className="span4">
                                                <div className="input-group">
                                                    <span className="input-group-addon ">Approved Period</span>
                                                    <select className="optionSpacer " data-ng-change="showResetWarning(quarterlyPeriod)" ng-model="quarterlyPeriod"><option value="? undefined:undefined ?"></option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tbody>
                                <tfoot>
                                </tfoot>
                            </table>
                        </div>
                        <div className="clearfix">

                        </div>
                    </div>
                </div>
            </div>
            {
                (() => {
                    if (newTransactionStatus) {
                        return <NewTransactionBox param={newTransactionStatus} NewTransactionClose={NewTransactionClose}/>
                    }
                })()
            }
            {
                (() => {
                    if (invoiceCheckStatus) {
                        return <InvoiceCheckBox param={invoiceCheckStatus} InvoiceCheckClose={InvoiceCheckClose}/>
                    }
                })()
            }
            {
                (() => {
                    if (invoiceDetailStatus) {
                        return <InvoiceDetailBox param={invoiceDetailStatus} InvoiceDetailClose={InvoiceDetailClose}/>
                    }
                })()
            }
            {
                (() => {
                    if (editInvoiceStatus) {
                        return <EditInvoiceBox param={editInvoiceStatus} EditInvoiceClose={EditInvoiceClose} />
                    }
                })()
            }
        </div>
    );
}